import { render, staticRenderFns } from "./SpinnerLoader.vue?vue&type=template&id=72424572"
import script from "./SpinnerLoader.vue?vue&type=script&lang=js"
export * from "./SpinnerLoader.vue?vue&type=script&lang=js"
import style0 from "./SpinnerLoader.vue?vue&type=style&index=0&id=72424572&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports